import React from 'react'
import GaugeChart from 'react-gauge-chart'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { scoreLevel, scoreLink } from './const'
// import ReactStoreIndicator from 'react-score-indicator'
import { Typography } from '@material-ui/core'

export default function ConfirmDialog(props) {
    const [open, setOpen] = React.useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const {
        openProps,
        title = 'IL TUO PUNTEGGIO',
        discardTitle = 'Chiudi',
        score,
    } = props

    return (
        <>
            <Button variant="outlined" color="primary" {...openProps} onClick={handleClickOpen}>
                {'Calcola'}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent>
                    <Typography id="alert-dialog-title" style={{
                        fontFamily: '"Bodoni Moda", Sans-serif',
                        fontSize: '30px',
                        lineHeight: '50px',
                        fontWeight: 600,
                        marginTop: '15px',
                        marginBottom: '15px',
                    }
                    }>{title}</Typography>
                    <GaugeChart id="gauge-chart1"
                        nrOfLevels={20}
                        percent={score / 40}
                        hideText={true}
                    />
                    {/*
                    <ReactStoreIndicator
                        value={score * 1}
                        maxValue={40}
                        stepsColors={[
                            '#3da940',
                            '#f1bc00',
                            '#d12000'
                        ]}
                        lineWidth={10}
                        fadedOpacity={30}
                    />
                    */}
                    <DialogContentText id="alert-dialog-description">
                        <Typography align='center' variant='h4' style={{marginTop: '20px', marginBottom:'25px'}}>{`Hai totalizzato ${score} punti`}</Typography>
                        {score >= 0 && score <= 13 && scoreLevel.level1}
                        {score >= 14 && score <= 26 && scoreLevel.level2}
                        {score >= 27 && score <= 40 && scoreLevel.level3}
                        {score >= 14 && score <= 26 && scoreLink.level2}
                        {score >= 27 && score <= 40 && scoreLink.level3}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" variant="outlined">
                        {discardTitle}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}